<template>
    <div class="subscribers--container">
        <data-container>
            <template #controls>
                    <AppDropdown
                        placeholder="Select"
                        v-model="filter.sort_by"
                        :options="sortItems"
                        :disabled="isLoading"
                        @input="fetchSubscriberList"
                    >
                        Sort by
                    </AppDropdown>
                    <div class="right--controls">
                        <AppButton modifier="small-primary" @click="$store.dispatch('subscriber/downloadList')">
                            Download List
                        </AppButton>
                        <AppTextField
                            v-model="filter.search"
                            placeholder="Type here"
                            icon-right="search"
                            @input="search"
                        />
                    </div>
            </template>
            <template #content>
                <AppTable
                    :dataset="subscriberList.data"
                    :fields="fields"
                    :selected="selectedItems"
                    :loading="isLoading"
                    @select="selectedItems = $event"
                    @endOfScroll="message('end of scroll')"
                    :total-count="subscriberList.total"
                    :current-page="parseInt(filter.page)"
                    :items-per-page="parseInt(filter.count)"
                    @changePage="changePage"
                />
            </template>
        </data-container>
    </div>
</template>

<script>
import DataContainer from '@/components/DataContainer'
import AppButton from '@/components/AppButton'
import AppDropdown from '@/components/AppDropdown'
import AppTextField from '@/components/AppTextField'
import AppTable from '@/components/AppTable'
import subscriber from '@/store/subscriber/app.js'
import { sortItems } from '@/utils/meta.js'
import { setQueryParams } from '@/utils/helpers.js'
import { mapGetters } from 'vuex'
import { mapFields } from 'vuex-map-fields'

export default {
	data () {
		return {
			selectedItems: [],
			fields: [
				{ name: 'transaction_id', text: 'Transaction ID', style: 'width: 12.5em;' },
				{ name: 'name', text: 'Name' },
				{ name: 'email', text: 'Email Address' },
				{ name: 'date_bind', text: 'Date Subscribed' },
				{ name: 'payment_method', text: 'Payment Method' },
				{ name: 'code', text: 'Code' }
			]
		}
	},

	methods: {
		search (val) {
			this.filter.page = 1
			this.filter.keyword = val
			clearTimeout(this.timeout)
			this.timeout = setTimeout(() => {
				this.fetchSubscriberList()
			}, 300)
		},

		fetchSubscriberList () {
		    const query = { ...this.filter }
			Object.keys(query).forEach(key => {
				!query[key] && (delete query[key])
			})
			query.theme_filter && (query.theme_filter = query.theme_filter.join('|'))
			this.$router.push({ query })
			const queryStr = setQueryParams(this.filter)
		    this.$store.dispatch('subscriber/list', queryStr.toLowerCase())
		},

		changePage ({ currentPage, itemsPerPage }) {
			this.filter.page = currentPage
			itemsPerPage !== this.filter.count && (this.filter.page = 1)
			this.filter.count = itemsPerPage
			this.fetchSubscriberList()
		}

	},
	computed: {
		...mapGetters('subscriber', [
			'subscriberList',
			'isLoading'
		]),
		...mapFields('subscriber', [
			'filter',
			'progress'
		]),
		sortItems () { return sortItems },
		subscriberPageCounter () {
			const { to, from } = this.subscriberList
			return `${from || 0} - ${to || 0}`
		}
	},
	created () {
		const query = { ...this.$route.query }
		if (Object.keys(query).length) {
			Object.keys(query).forEach(key => {
				!query[key] && (delete query[key])
			})
			this.filter = { ...query }
		}
		this.fetchSubscriberList()
	},
	beforeCreate () {
		if (!this.$store.hasModule('subscriber')) {
			this.$store.registerModule('subscriber', subscriber)
		}
	},
	components: {
		DataContainer,
		AppButton,
		AppTextField,
		AppDropdown,
		AppTable
	}
}
</script>

<style lang="scss" scoped>
.subscribers--container {
    padding: 1.5em;
}

.app-dropdown {
    min-width: 120px;
}

.custom-table {
    margin-top: 12px;
}

.right--controls{
    margin-top: 16px;
    display: flex;
    justify-content: flex-end;
    flex-grow: 1;

    .app-button--small-primary {
        margin-right: 12px;
    }
}

/deep/ .app-popup {
    width: 30em;
    padding: 16px 0;
}

.app-count-picker {
    margin-right: 5px;
}

.pagination--counter {
    display: flex;
    flex: 1;
    font-size: 1.2em;
}
</style>
